/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Continue_With_EmailInputs */

const en_auth_continue_with_email = /** @type {(inputs: Auth_Continue_With_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with email`)
};

const es_auth_continue_with_email = /** @type {(inputs: Auth_Continue_With_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con correo electrónico`)
};

/**
* | output |
* | --- |
* | "Continue with email" |
*
* @param {Auth_Continue_With_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_continue_with_email = /** @type {((inputs?: Auth_Continue_With_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Continue_With_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_continue_with_email(inputs)
	return en_auth_continue_with_email(inputs)
});